import React from "react";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/HeroSection/Hero";
import ContactForm from "../../components/Contact/ContactForm";

import HeroImage from "../../assets/images/mandirin.png";

import "./contactUs.css";

function Contact() {
  return (
    <div>
      <head>
        <title>Contact Us</title>
      </head>
      
      <Header />
      <HeroSection
        backgroundImage={HeroImage}
        title="We are here to help"
        subtitle="Get in touch"
        dividerPath="M0,64L48,90.7C96,117,192,171,288,213.3C384,256,480,288,576,250.7C672,213,768,107,864,85.3C960,64,1056,128,1152,154.7C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        dividerColour="white"
      />

      <div className="ContactContainer">
        <div className="ContactInfoContainer">
          <h2>Contact Us</h2>
          <h3>Blendz 2010 Limited</h3>
          <a href="tel:0800264948">Phone: 0800 2 MIX IT</a>
          <br />
          <a href="tel:0800264948">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(0800
            264 948)
          </a>
          <br />
          <a href="mailto:info@blendz.co.nz">Email: info@blendz.co.nz</a>
          <p>Address: 282 Fordyce Road RD1</p>
          <p>Helensville, Auckland 0874</p>
          <p>New Zealand</p>
        </div>
        <ContactForm />
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
